import { cn } from "@/lib/utils";

// Accessible segmented single-choice control.
export default function Segmented({ label, value, options, onChange, testId }) {
  return (
    <div
      role="radiogroup"
      aria-label={label}
      className="inline-flex flex-wrap gap-1 rounded-lg border border-le-border bg-le-subtle p-1"
      data-testid={testId}
    >
      {options.map((o) => {
        const on = value === o.value;
        return (
          <button
            key={o.value}
            type="button"
            role="radio"
            aria-checked={on}
            disabled={o.disabled}
            title={o.hint}
            onClick={() => onChange(o.value)}
            data-testid={`${testId}-${o.value}`}
            className={cn(
              "px-3 py-1.5 rounded-md text-sm font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed",
              "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-le-focus focus-visible:ring-offset-1",
              on ? "bg-le-primary text-white shadow-sm" : "text-le-t-2 hover:bg-le-selected/60 hover:text-le-text"
            )}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
